import { render, staticRenderFns } from "./PointsLog.vue?vue&type=template&id=2a7f1ea1&scoped=true"
import script from "./PointsLog.vue?vue&type=script&lang=js"
export * from "./PointsLog.vue?vue&type=script&lang=js"
import style0 from "./PointsLog.vue?vue&type=style&index=0&id=2a7f1ea1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7f1ea1",
  null
  
)

export default component.exports